import { Skeleton, Stack } from "@mui/material";

export const LearningActivityContentSkeleton = () => (
  <Stack gap={ "2rem" } aria-hidden="true">
    <Stack gap={ "0.5rem" }>
      <Skeleton variant="text" animation="wave" width="100%" height="1.25rem" />
      <Skeleton variant="text" animation="wave" width="90%" height="1.25rem" />
      <Skeleton variant="text" animation="wave" width="60%" height="1.25rem" />
    </Stack>

    <Stack flexDirection={ "row" } justifyContent={ "space-between" } alignItems={ "center" }>
      <Skeleton variant="rounded" animation="wave" width="9rem" height="2.5rem" />
      <Skeleton variant="circular" animation="wave" width="2.5rem" height="2.5rem" />
    </Stack>

    <Stack gap={ "1rem" }>
      <Stack flexDirection={ "row" } gap={ "1rem" }>
        <Skeleton variant="rounded" animation="wave" width="6rem" height="2rem" />
        <Skeleton variant="rounded" animation="wave" width="6rem" height="2rem" />
        <Skeleton variant="rounded" animation="wave" width="6rem" height="2rem" />
      </Stack>
      <Skeleton variant="rounded" animation="wave" width="100%" height="9rem" />
    </Stack>
  </Stack>
);
